<template>
  <header class="main-header-wrapper">
    <div :class="['main-header-container', {'is-active-menu' : isActiveMenu}]">
      <transition name="fade-opacity-lazy" mode="out-in">
        <div class="img-container logo"
             v-if="!isActiveMenu"
             @click="scrollToTopBlock">
          <img :src="getUrlLogo(logoImgHover)" alt="logo">
        </div>
        <div class="icon-container"
             v-else
             @click="scrollToTopBlock">
          <img :src="getUrlLogo(isLogoDark && !isisActiveMenu
              ? 'logo-icon-dark'
              : 'logo-icon')" alt="logo">
        </div>
      </transition>
      <div class="img-container menu" @click="changeStateMenu" :class="{'cross' : isActiveMenu}">
        <transition name="fade-rotate" mode="out-in">
                <img v-if="!isActiveMenu"  :src="getUrlIcons(menuIcon)" alt="logo">
                <img v-else :src="getUrlIcons(crossIcon)" alt="logo">
        </transition>
      </div>

    </div>
    <transition name="fade-translate-x-card-revert">
        <menu-burger v-show="isActiveMenu"
                     @scrollTo="scrollTo"
                     :menu-info="menuInfo"/>
    </transition>
  </header>
</template>

<script>
import MenuItem from "@/components/widgets/MenuItem.vue";
import MainButton from "@/components/shared/MainButton.vue";
import MenuBurger from "@/components/widgets/MenuBurger.vue";

export default {
  name: "MainHeaderMobile",
  components: {MenuBurger, MainButton, MenuItem},
  props: {
    menuInfo: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      btnText: 'Оставить заявку',
      isActiveMenu: false,
      timer: null,
      logoImgHover: 'logo',
      menuIcon: 'menu',
      crossIcon: 'cross-white'
    }
  },
  methods: {
    changeStateMenu() {
      this.isActiveMenu = !this.isActiveMenu
    },
    scrollTo(id) {
      this.isActiveMenu = false;
      this.$emit('scrollTo', id, false)
    }
  }
}
</script>

<style scoped lang="scss">
.main-header-wrapper {
  z-index: 950;
  position: fixed;
  top: 0;
  width: 100%;
  .main-header-container {
    transition: all .3s ease;
    backdrop-filter: blur(30px);
    position: relative;
    z-index: 901;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    &.is-active-menu {
      backdrop-filter: blur(0);
    }

    .icon-container {
      position: relative;
      left: -2%;
      min-width: 56px;
      width: 0;
      height: 100%;
      & img {
        width: 100%;
        height: 100%;
      }
    }

    .img-container {
      position: relative;
      transition: all .3s ease;
      width: 0;
      height: 100%;
      & img {
        position: relative;
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
  }

  .menu-burger-container {
    z-index: 900;
    position: absolute;
    width: var(--calc-width);
    height: var(--calc-height);
    top: 0;
    left: 0;
    background: var(--color-dark-purple);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .action-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  }
}

@media (max-width: 769px) {
  .main-header-wrapper {
    height: 62px;
    .main-header-container {
      padding: 20px 20px 10px;

      .img-container {
        &.logo {
          min-width: 83px;
        }
        &.menu {
          transition: all .6s ease;
          position: relative;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          max-width: 32px;
          min-width: 32px;
          &.cross {
            padding: 10px;
          }
          & img {
            position: relative;
          }
        }
      }
    }

    .menu-burger-container {
      padding: 90px 22px 40px;
    }
  }
}
</style>
